import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { SnackbarProvider } from 'notistack';
import { HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import './App.scss'
import Menu from './components/Menu'
import Home from './pages/Home/Home'
import Services from './pages/Services/Services'
import About from './pages/About/About'
import MV from './pages/MV/MV'
import Gallery from './pages/Gallery/Gallery'
import ContactUs from './pages/ContactUs/ContactUs'
import Footer from './pages/Footer/Footer'

function ScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [hash]);

  return null;
}

const Layout = () => {
  return (
    <div className='App'>
      <SnackbarProvider preventDuplicate>
        <Menu />
        <Home />
        <Services />
        <About />
        <MV />
        <Gallery />
        <ContactUs />
        <Footer />
      </SnackbarProvider>
    </div>
  )
}

function App () {
  return (
    <HelmetProvider>
      <BrowserRouter>
      <ScrollToHash />
        <Routes>
          <Route path='/' element={<Layout />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  )
}

export default App
